import { render, staticRenderFns } from "./TermsAndConditionsDisplay.vue?vue&type=template&id=856870c6&"
import script from "./TermsAndConditionsDisplay.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports